import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'core/auth-guard/auth-guard.service';
import { NsLocaleGuard } from 'core/ns-locale-guard/ns-locale.guard';
import { FeaturedProductsComponent } from './featured-products/featured-products.component';
import { CategoriesComponent } from './products/categories/categories.component';
import { ProductDetailsComponent } from './products/product-details/product-details.component';
import { ProductsSearchResultsComponent } from './products/products-search/products-search-results.component';
import { ProductsComponent } from './products/products.component';

const routes: Routes = [
  { path: 'tools/catalogs', component: ProductsComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'tools/categories/:catalogCode', component: CategoriesComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'tools/categories/:catalogCode/:categoryId', component: CategoriesComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'tools/featured-products', component: FeaturedProductsComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'tools/search/:searchText', component: ProductsSearchResultsComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'tools/product/:catalogCode/:partNumber', component: ProductDetailsComponent, canActivate: [AuthGuard, NsLocaleGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class MarketingRoutingModule {}
